import type { CSSProperties } from "react";
import "./skeleton.css";

type Props = {
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
  className?: string;
  style?: CSSProperties;
};

const SkeletonBlock = ({ width = "100%", height = 16, className, style }: Props) => (
  <div
    className={`skeleton-block${className ? ` ${className}` : ""}`}
    style={{ width, height, ...style }}
    aria-hidden="true"
  />
);

export default SkeletonBlock;
